var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavSingleOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 25.88,
    viewBox: "0 -0.94 24 25.88",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.757 4.141 18.196.859C17.421.144 15.889-.44 14.792-.44H2.827C1.73-.44.833.387.833 1.398v19.849c0 1.011.898 1.838 1.994 1.838h18.346c1.097 0 1.994-.827 1.994-1.838V7.277c0-1.01-.635-2.422-1.41-3.136M20.629 5.18q.117.108.231.26h-4.074V1.685q.163.105.282.213zm.942 16.065c0 .199-.183.367-.399.367H2.827c-.217 0-.399-.169-.399-.367V1.397c0-.199.183-.367.399-.367h11.965q.183 0 .399.039v5.842h6.338q.041.2.042.367z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.643 10.037-6.663-.969L12 3.031 9.021 9.068l-6.663.969 4.822 4.7-1.14 6.636L12 18.24l5.96 3.133-1.138-6.636zM12 16.75l-4.209 2.213.803-4.686-3.404-3.32 4.705-.684L12 6.01l2.105 4.264 4.705.684-3.405 3.319.803 4.686z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "red"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.833 23.364H8v1.391H.833zM16 23.364h7.167v1.391H16zM11.044 23.364h1.911v1.391h-1.911z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavSingleOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fav-single-on.svg";